/**
 * Local SEO areas data — each entry produces a dedicated landing page at
 * /{slug}. Content is UNIQUE per area (Google duplicate content guardrails).
 *
 * Pharmacie Saint Ange Des Amis physical location:
 *   Angré 7ème Tranche, Carrefour Bluetooth, Cocody, Abidjan.
 * All areas below are within 5–15 min driving distance.
 */

export const LOCAL_AREAS = {
  'pharmacie-riviera-golf': {
    slug: 'pharmacie-riviera-golf',
    area_name: 'Riviera Golf',
    area_name_long: 'la Riviera Golf',
    distance_min: 8,
    distance_description: '8 à 12 minutes en voiture via le Boulevard Latrille',
    badge_label: 'Pharmacie proche de la Riviera Golf',
    title:
      "Pharmacie près de la Riviera Golf — Commandes France, laits infantiles rares, dermo-cosmétique",
    description:
      "Résidents de la Riviera Golf, la Pharmacie Saint Ange Des Amis est à 8–12 min par Boulevard Latrille. Hall aéré, parapharmacie fournie, commandes France/Suisse, laits infantiles spécialisés, produits FIV, conseil dermo-cosmétique par IA.",
    keywords: [
      'pharmacie Riviera Golf',
      'pharmacie Riviera Abidjan',
      'pharmacie proche Riviera',
      'parapharmacie Riviera',
      'commande produits France Riviera',
      'laits infantiles rares Riviera',
      'Pharmacie Saint Ange Des Amis',
    ],
    hero_h1_accent: 'proche de la Riviera Golf',
    hero_intro:
      "Depuis la Riviera Golf, rejoignez la Pharmacie Saint Ange Des Amis en 8 à 12 minutes par le Boulevard Latrille puis Angré 7ème Tranche. Nous desservons au quotidien de nombreuses familles de la Riviera Golf, Riviera M'Badon, Riviera 3 et Riviera Palmeraie grâce à notre parapharmacie particulièrement fournie, nos commandes directes depuis la France et la Suisse, et un conseil pharmaceutique approfondi de notre équipe jeune et dynamique.",
    audience_profile:
      "Notre clientèle de la Riviera Golf compte beaucoup de familles expatriées, de cadres en poste dans les grandes entreprises de Cocody-Plateau, et de parents exigeants sur la qualité des produits dermo-cosmétiques et infantiles. Nous avons adapté nos stocks en conséquence : gammes parapharmacie premium (La Roche-Posay, Avène, Bioderma, Nuxe, Caudalie, Uriage), laits infantiles spécialisés (Gallia, Guigoz, Modilac AR, Novalac, Nutriben), et service de commande rapide depuis la France pour tout produit manquant.",
    faq: [
      {
        question: 'Combien de temps faut-il pour venir de la Riviera Golf à la Pharmacie Saint Ange Des Amis ?',
        answer:
          "Comptez 8 à 12 minutes en voiture hors heures de pointe. Le trajet le plus fluide passe par le Boulevard Latrille, puis rejoint Angré 7ème Tranche et le Carrefour Bluetooth. Aux heures de pointe, prévoyez 20 à 25 minutes. De nombreux clients de la Riviera nous rendent visite en dehors des heures de pointe pour bénéficier de nos stocks complets.",
      },
      {
        question: 'Proposez-vous la commande de produits introuvables sur Abidjan ?',
        answer:
          "Oui, nous effectuons régulièrement des commandes directes depuis la France et la Suisse pour nos clients de la Riviera et de tout Cocody. Livraison à la pharmacie sous 10 jours ouvrés en moyenne. Idéal pour les produits de dermatologie prescrits en Europe, les compléments alimentaires spécifiques, les produits pédiatriques spécialisés ou les marques absentes du marché ivoirien.",
      },
      {
        question: 'Avez-vous un large choix de laits infantiles ?',
        answer:
          "Oui, notre rayon laits infantiles est l'un des plus fournis d'Angré : formules standards et spécialisées (anti-régurgitation, hypoallergénique, épaissi, prématurés, sans lactose) des marques Gallia, Guigoz, Modilac AR, Novalac, Nutriben. Si un lait n'est pas en stock, nous le commandons sous 48–72 heures.",
      },
      {
        question: "Quels sont les horaires d'ouverture ?",
        answer:
          "Du lundi au vendredi de 7h30 à 20h00, le samedi de 7h30 à 13h00. Dimanche fermé (sauf semaine de garde). Nous participons régulièrement au tableau des pharmacies de garde d'Abidjan avec un accueil 24h/24 pendant notre semaine de garde.",
      },
    ],
  },

  'pharmacie-2-plateaux': {
    slug: 'pharmacie-2-plateaux',
    area_name: 'Deux Plateaux',
    area_name_long: 'les Deux Plateaux',
    distance_min: 6,
    distance_description: '6 à 10 minutes en voiture via la Rue des Jardins',
    badge_label: 'Pharmacie proche des Deux Plateaux',
    title:
      "Pharmacie proche des Deux Plateaux — Parapharmacie fournie, produits rares, conseil dermo",
    description:
      "Pour les résidents des Deux Plateaux, la Pharmacie Saint Ange Des Amis est à 6–10 min en voiture. Hall spacieux, équipe jeune, commandes France & Suisse, laits infantiles, produits FIV, SADASkinCare (conseil dermo par IA), suivi santé personnalisé.",
    keywords: [
      'pharmacie Deux Plateaux',
      'pharmacie 2 Plateaux',
      'pharmacie Deux Plateaux Vallons',
      'pharmacie Deux Plateaux ENA',
      'parapharmacie Deux Plateaux',
      'pharmacie bien achalandée Cocody',
      'Pharmacie Saint Ange Des Amis',
    ],
    hero_h1_accent: 'proche des Deux Plateaux',
    hero_intro:
      "Nous sommes l'une des pharmacies les plus fréquentées par les habitants des Deux Plateaux — Vallons, ENA, Vallon, SIDECI. Depuis les Deux Plateaux, vous nous rejoignez en 6 à 10 minutes en voiture (Rue des Jardins puis Angré 7ème Tranche). Notre parapharmacie est reconnue comme l'une des mieux achalandées de Cocody : gammes françaises complètes, laits infantiles spécialisés, produits FIV, commande directe des produits introuvables en Côte d'Ivoire.",
    audience_profile:
      "De nombreuses familles installées aux Deux Plateaux depuis plusieurs années nous ont fait confiance pour leur suivi dermo-cosmétique, leur diabète, leur HTA, leurs enfants nourrissons. Notre hall aéré et notre espace de confidentialité d'excellent standing permettent des consultations dans le calme, même aux heures d'affluence. Nous proposons par ailleurs un conseil en dermo-cosmétique par intelligence artificielle (SADASkinCare) et un suivi personnalisé de vos paramètres de santé (tension, glycémie, IMC, SpO₂) avec rapport PDF imprimable aux normes OMS.",
    faq: [
      {
        question: 'Quelle est la distance entre les Deux Plateaux et la Pharmacie Saint Ange Des Amis ?',
        answer:
          "Environ 4 à 5 km selon votre point de départ aux Deux Plateaux (Vallons, ENA, SIDECI, Vallon). Comptez 6 à 10 minutes de trajet en voiture hors heures de pointe, 15 à 20 minutes en période dense. L'itinéraire passe par la Rue des Jardins puis Angré 7ème Tranche jusqu'au Carrefour Bluetooth.",
      },
      {
        question: 'Proposez-vous des conseils en dermo-cosmétique ?',
        answer:
          "Oui, nous avons une équipe formée aux produits dermo-cosmétiques des marques La Roche-Posay, Avène, Bioderma, Nuxe, Caudalie, Uriage, Sensibio, Effaclar et autres. Pour un diagnostic plus poussé, nous proposons également un conseil gratuit par application d'intelligence artificielle (SADASkinCare) qui analyse votre peau et recommande les soins adaptés.",
      },
      {
        question: 'Suivez-vous les patients diabétiques ou hypertendus ?',
        answer:
          "Oui. Au-delà de la dispensation des médicaments, nous offrons un suivi personnalisé de vos paramètres : tension artérielle, glycémie, IMC, SpO₂. Chaque mesure est enregistrée et vous pouvez recevoir un rapport PDF imprimable aux normes OMS pour votre médecin traitant. Un vrai plus pour optimiser votre prise en charge chronique.",
      },
      {
        question: 'Acceptez-vous les ordonnances électroniques ?',
        answer:
          "Oui, vous pouvez nous transmettre votre ordonnance par WhatsApp, email ou dépôt sur place. Nous vérifions la disponibilité, vous confirmons le total et préparons votre commande pour retrait. Très pratique pour les clients des Deux Plateaux qui peuvent s'organiser à l'avance.",
      },
    ],
  },

  'pharmacie-angre-8e-tranche': {
    slug: 'pharmacie-angre-8e-tranche',
    area_name: 'Angré 8ème Tranche',
    area_name_long: "l'Angré 8ème Tranche",
    distance_min: 3,
    distance_description: '3 à 5 minutes en voiture — quartier voisin',
    badge_label: 'Votre pharmacie de référence à Angré 8ème Tranche',
    title:
      "Pharmacie Angré 8ème Tranche — La plus proche, la plus complète à 3 min de chez vous",
    description:
      "Habitants d'Angré 8ème Tranche, la Pharmacie Saint Ange Des Amis est à 3 à 5 minutes de chez vous au Carrefour Bluetooth. Parapharmacie fournie, laits infantiles, produits FIV, commandes France, conseil dermo par IA, suivi santé. Ouvert Lun-Ven 7h30-20h.",
    keywords: [
      'pharmacie Angré 8ème tranche',
      'pharmacie Angré 8e tranche',
      'pharmacie Angré 8',
      'pharmacie Angré proche',
      'parapharmacie Angré',
      'pharmacie de référence Angré',
      'Pharmacie Saint Ange Des Amis',
    ],
    hero_h1_accent: "à Angré 8ème Tranche (à 3 min)",
    hero_intro:
      "Pour les résidents d'Angré 8ème Tranche, la Pharmacie Saint Ange Des Amis est la pharmacie de référence la plus proche — à seulement 3 à 5 minutes en voiture, au Carrefour Bluetooth en 7ème Tranche. Nous recevons quotidiennement des familles de la 8ème Tranche qui apprécient notre hall aéré, notre équipe jeune et dynamique, et surtout notre stock toujours à jour sur les médicaments courants, la parapharmacie et les produits pédiatriques.",
    audience_profile:
      "La proximité est votre premier critère : en 8ème Tranche, nos clients viennent souvent en urgence pour un antalgique, un antipyrétique, un sirop pour enfant, un pansement ou un complément alimentaire. Nous avons structuré notre pharmacie pour que ces produits soient immédiatement disponibles, sans aucune rupture de stock sur les essentiels. Pour les besoins plus techniques (dermatologie, FIV, laits infantiles spécialisés), notre rayon est probablement le mieux achalandé à moins de 5 km, et nous commandons les produits rares en France ou en Suisse sous 10 jours.",
    faq: [
      {
        question: 'Combien de minutes pour venir de la 8ème Tranche ?',
        answer:
          "3 à 5 minutes en voiture en moyenne, suivant votre emplacement exact dans la 8ème Tranche et les conditions de trafic. Nous sommes le Carrefour Bluetooth en 7ème Tranche, donc dans un rayon immédiat de chez vous.",
      },
      {
        question: "Avez-vous tous les médicaments courants en stock ?",
        answer:
          "Oui, nous faisons de la gestion de stock quotidienne une priorité absolue : les médicaments courants (antalgiques, antipyrétiques, antibiotiques les plus prescrits, antihistaminiques, antidiarrhéiques, sirops pédiatriques) sont toujours disponibles. Ruptures rares et réapprovisionnement sous 24h quand elles surviennent.",
      },
      {
        question: "Peut-on vous déposer une ordonnance et revenir plus tard ?",
        answer:
          "Absolument. Vous pouvez déposer votre ordonnance en pharmacie ou nous l'envoyer par WhatsApp / email. Nous préparons votre commande et vous appelons dès qu'elle est prête. Idéal quand vous êtes pressée.",
      },
      {
        question: "Faites-vous partie du tableau des pharmacies de garde ?",
        answer:
          "Oui, nous participons très régulièrement au tableau des pharmacies de garde d'Abidjan. Pendant notre semaine de garde, nous sommes ouverts 24h/24 — une ressource précieuse pour les urgences nocturnes des habitants de la 8ème Tranche.",
      },
    ],
  },

  'pharmacie-djibi': {
    slug: 'pharmacie-djibi',
    area_name: 'Djibi',
    area_name_long: 'le Djibi',
    distance_min: 5,
    distance_description: '5 à 8 minutes en voiture — accès direct depuis la voie Djibi / Angré',
    badge_label: 'Pharmacie proche de Djibi (Abobo-Djibi)',
    title:
      "Pharmacie proche de Djibi — Parapharmacie, laits infantiles, commandes France, dermo IA",
    description:
      "Habitants du Djibi et d'Abobo-Djibi, la Pharmacie Saint Ange Des Amis est à 5–8 min en voiture au Carrefour Bluetooth (Angré 7ème Tranche). Hall aéré, équipe jeune, commandes France et Suisse, laits infantiles spécialisés, produits FIV, conseil dermo-cosmétique par IA.",
    keywords: [
      'pharmacie Djibi',
      'pharmacie Abobo Djibi',
      'pharmacie proche Djibi',
      'pharmacie Angré Djibi',
      'parapharmacie Djibi',
      'pharmacie bon accueil Djibi',
      'Pharmacie Saint Ange Des Amis',
    ],
    hero_h1_accent: 'proche du Djibi',
    hero_intro:
      "Pour les habitants du Djibi et d'Abobo-Djibi, la Pharmacie Saint Ange Des Amis est accessible en 5 à 8 minutes en voiture par la voie Djibi/Angré jusqu'au Carrefour Bluetooth en 7ème Tranche. Nous accueillons quotidiennement des familles du Djibi qui apprécient particulièrement notre large parapharmacie, nos laits infantiles spécialisés et notre service de commandes directes depuis la France et la Suisse pour tout produit introuvable à Abidjan.",
    audience_profile:
      "Notre clientèle du Djibi vient souvent pour des ordonnances complètes, le suivi de petit enfant (laits, produits d'hygiène, sirops pédiatriques), ou des achats de parapharmacie (crèmes, solaires, savons dermatologiques). Pour les besoins urgents, sachez que nous pratiquons de la gestion de stock quotidienne sur les essentiels — les ruptures sur les médicaments courants sont très rares chez nous.",
    faq: [
      {
        question: 'Quel est l\'itinéraire depuis Djibi pour venir à la pharmacie ?',
        answer:
          "Depuis Djibi, prenez la voie Djibi/Angré qui rejoint directement Angré 7ème Tranche, puis continuez jusqu'au Carrefour Bluetooth. Comptez 5 à 8 minutes en voiture hors heures de pointe, 12 à 15 minutes en période dense. Un itinéraire Google Maps direct est disponible sur notre site.",
      },
      {
        question: 'Commandez-vous des produits introuvables sur Abidjan ?',
        answer:
          "Oui. Pour les dermocosmétiques de pointe, les compléments alimentaires spécifiques, les produits de fertilité ou tout produit prescrit en Europe, nous réalisons des commandes directes en France et en Suisse avec livraison en pharmacie sous 10 jours ouvrés en moyenne. Un service précieux pour les familles du Djibi suivant un traitement particulier.",
      },
      {
        question: 'Avez-vous du lait infantile spécifique (anti-régurgitations, hypoallergénique…) ?',
        answer:
          "Oui, notre rayon laits infantiles est extrêmement fourni : formules standard, anti-régurgitations (AR), hypoallergéniques (HA), épaissies, pour prématurés, sans lactose, des marques Gallia, Guigoz, Modilac, Novalac, Nutriben. Nous conseillons également le choix adapté selon l'âge et les symptômes de bébé.",
      },
      {
        question: "Quels sont vos horaires et votre numéro de téléphone ?",
        answer:
          "Lundi au vendredi 7h30–20h00, samedi 7h30–13h00. Téléphone : 07 78 41 52 77 ou 27 22 30 05 72. En cas de garde (24h/24), appelez pour confirmer. L'adresse : Carrefour Bluetooth, Angré 7ème Tranche, Cocody, Abidjan (dans l'enceinte de l'ancien Bar Bluetooth).",
      },
    ],
  },
};

export const LOCAL_AREA_SLUGS = Object.keys(LOCAL_AREAS);

export default LOCAL_AREAS;
